import React from 'react';

const Pay = () => {
    return (
        <div>
            Payment system coming soon
        </div>
    );
};

export default Pay;